import { I18n } from './utils/i18n';
var JarvisAssetsProvider = /** @class */ (function () {
    /**
     * The constructor will attempt to find the the best locale match given the language and country you have specified.
     * If an exact match of language and country is not available, it will attempt to use a fallback locale for that same language.
     * If no fallback is available for that language it will fallback to using the default english locale.
     *
     * @param localeToStringsJson Mapping of locales to a translated string json structure. {@link LocaleToStringsJson Example}
     * @param language Language Code (ISO 639-1 format) defaults to 'en'
     * @param country Country Code (ISO 3166-1 alpha-2 format) defaults to 'US
     */
    function JarvisAssetsProvider(localeToStringsJson, language, country) {
        if (language === void 0) { language = 'en'; }
        if (country === void 0) { country = 'US'; }
        this.localeSeparator = '_';
        this.rtlLanguages = ['ar', 'he'];
        if (language.length !== 2) {
            throw new Error("Invalid language (" + language + ").  Language should be the 2 character ISO 639-1 format");
        }
        if (country.length !== 2) {
            throw new Error("Invalid country (" + country + ").  Country should be the 2 character ISO 3166-1 alpha-2 format");
        }
        language = language.toLowerCase();
        country = country.toUpperCase();
        this.i18n = new I18n(localeToStringsJson, language + this.localeSeparator + country);
    }
    /**
     * Accessor function to the private localeCode.
     *
     * @returns The locale that will be used to index into the localeToStringsJson.
     * This is based off of the language and country passed into the constructor.
     */
    JarvisAssetsProvider.prototype.getLocaleCode = function () {
        return this.i18n.getLocaleCode();
    };
    /**
     * Currently unimplemented and will throw an error if invoked.
     * Also see {@link AssetsProvider AssetProvider interface}
     *
     * @returns
     */
    JarvisAssetsProvider.prototype.getImage = function (imageId) {
        throw new Error('No images currently defined');
    };
    /**
     * Also see {@link AssetsProvider AssetProvider interface}
     *
     * @param textId The string to index within the locale's json
     * @param keys If the string contains interpolation {{}}, the interpolation placeholder will
     * be substituted with the corresponding value within the keys Record.
     * @returns the localized string or if that textID can not be found it will return the textId,
     * or the input textId if no localized text asset exists with that id
     */
    JarvisAssetsProvider.prototype.getText = function (textId, keys) {
        return this.i18n.t(textId, keys);
    };
    /**
     * Helper function to extract the language code from getLocaleCode.
     *
     * @returns the language code in ISO 639-1 format.
     * This is based off of the language and country passed into the constructor.
     */
    JarvisAssetsProvider.prototype.getLanguage = function () {
        return this.getLocaleCode().split(this.localeSeparator)[0];
    };
    /**
     * Helper function to extract the country code from getLocaleCode.
     *
     * @returns the country code in ISO 3166-1 alpha-2 format.
     * This is based off of the language and country passed into the constructor.
     */
    JarvisAssetsProvider.prototype.getCountry = function () {
        return this.getLocaleCode().split(this.localeSeparator)[1];
    };
    /**
     * Helper function to extract the text direction from getLanguage.
     *
     * @returns 'ltr' or 'rtl' based on language.
     * This is based off of the language and country passed into the constructor.
     */
    JarvisAssetsProvider.prototype.getDirection = function () {
        return this.rtlLanguages.indexOf(this.getLanguage()) >= 0 ? 'rtl' : 'ltr';
    };
    return JarvisAssetsProvider;
}());
export { JarvisAssetsProvider };
export default JarvisAssetsProvider;
//# sourceMappingURL=JarvisAssetsProvider.js.map